// import { useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { ErrorOverlay, LoadingOverlay } from "@/components/overlay";
import { BootstrapState } from "@/components/sync/types";
import { appRoutes } from "@/app/router/appRoutes";
import { FloatingAgentLoadingOverlay } from "@/pages/floating-agent/floating-agent-window-chrome";
import { useAppStore } from "@/store";
import { BOOTSTRAP_TIMEOUT } from "@/store/sync/constants";
import { useInterval } from "usehooks-ts";

export const BootstrapOverlay = observer(function BootstrapOverlay() {
  const { store } = useAppStore();
  const bootstrapState = store.sync.bootstrapState;
  const bootstrapProgressMessage = store.sync.bootstrapProgressMessage;
  const isBootstrapActiveTab = store.sync.isBootstrapActiveTab;
  const isInitializationFailed = store.sync.initializationFailed;

  const isLoading =
    bootstrapState === BootstrapState.Downloading || bootstrapState === BootstrapState.Processing;
  const showBootstrapError = bootstrapState === BootstrapState.Failed && !isInitializationFailed;

  useInterval(async () => {
    if (!isLoading || isBootstrapActiveTab) {
      return;
    }

    await store.sync.checkBootstrapStatus();
  }, BOOTSTRAP_TIMEOUT);

  // The floating-agent widget lives in a transparent BrowserWindow — the
  // standard full-screen loading overlay would paint an opaque backdrop.
  const location = useLocation();
  const isFloatingAgentWindow = location.pathname === appRoutes.floatingAgent({}).path;

  return (
    <>
      <ErrorOverlay isVisible={showBootstrapError} />
      {isFloatingAgentWindow ? (
        <FloatingAgentLoadingOverlay isVisible={isLoading} />
      ) : (
        <LoadingOverlay isVisible={isLoading} loadingMessage={bootstrapProgressMessage} />
      )}
    </>
  );
});
